
<template>
  <base-info-card-marker @click="handleClick" :marker_color="project.json_attributes.color">
    <template slot="icon">
      <v-col cols="12" sm="3" md="3" class="pa-0">
        <span class="mx-1 black--text ">{{project.name}}</span>
      </v-col>
    </template>

    
    <template slot="text">
      <v-row class="px-3 black--text" align='center'>
        <v-col v-if='this.stages.length > 0' cols="6" class="pa-0">
          <b class="ml-4">Fase atual: </b>
          <span>{{ stages[0].name}}</span>
        </v-col>
        <v-col v-else cols="6" class="pa-0">
          <b class="ml-4">Fase atual: </b>
          <span>Sem fase</span>
        </v-col>
        <v-col class="pa-0">
          <v-row class="px-3" align='center'>
            Status 
            <v-tooltip top>
              <template v-slot:activator="{on}">
                <v-avatar v-on="on" size="20" :color="`status_${project.status}`" class="ml-1">
                  <v-icon x-small :color="`status_${project.status}_dot`">mdi-circle</v-icon>
                </v-avatar>
              </template>
             {{ $t(`statuses.${project.status}`) }}
            </v-tooltip>
          </v-row>
        </v-col>
        <v-col class="pa-0">
          <v-tooltip top v-for="user in project.users" :key="user.id">
            <template v-slot:activator="{on}">
              <v-icon v-on="on">mdi-account-circle</v-icon>
            </template>
            {{ user.name }}
          </v-tooltip>
        </v-col>
      </v-row>
    </template>
    <template slot="last">
      <span class="black--text">
        Conclusão: <b>{{ $dayjs(project.expected_conclusion_at).format('DD/MM/YYYY')}}</b>
      </span>
    </template>
  </base-info-card-marker>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
//import validations from '@/mixins/validations'
import Api from '@/api/index';

export default {
  name: 'ProjectSmallCard',
  //mixins: [ validations ],
  props: {
    project: {
      type: Object,
      default: () => {}
    },
  },
  components: {
    //ComponentName: () => import(''),
  },
  data() {
    return {
      stages:[]
    }
  },
  methods: {
    getStages(){
      this.loading = true
      Api.Stage.index({project_id: this.project.id, use_type: ['template'], sorts: {position: 'asc'}}).then(r=>r.data).then(d=> {
        this.stages = [...d]
        // console.log('stage',this.project.id,this.stages)
        // if (this.stages.length == 0) {
        //   const object = {
        //     id: 0, name: 'Sem Fase'
        //   }
        //   this.stages.push(object)
          
        // }
      }).catch(err=> {
        console.log({err});
      }).finally(()=> this.loading = false)
    },
    
    handleClick(e) {
      this.$router.push({name: 'OneProject', params: {id: this.project.id}})
    },
    ...mapActions({
      // function: 'Module/action'
      //addNotification: 'Notification/add'
    })
  },
  mounted () {
    this.getStages()
  },
  computed: {
    
    ...mapState({
      
      // data: state=> state.Module.state_var
    })
  },
}
</script>

<style scoped>

</style>